module.exports = __webpack_public_path__ + "img/e61fcd2.jpg";